<template>
  <div class="lokakarya mb-5">
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          :options="{
            header: 'pa-0',
            filterOutline: true,
            reloadOutline: true,
            searchOutline: true,
            downloadOutline: true,
          }"
          :search-input="false"
          :btn-download="true"
          @reload="onReload"
          @download="onDownloadList"
          @search="onSearch"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              <h4 class="black--text">Daftar Penjadwalan Kegiatan Kelompok</h4>
            </div>
          </template>
          <template v-slot:toolbar>
            <div style="max-width: 180px" class="mr-2">
              <v-select
                v-model="gelombang"
                light
                flat
                dense
                outlined
                hide-details
                :items="mGelombang"
                @change="onChangeGelombang"
              ></v-select>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-expansion-panels multiple accordion flat>
        <v-expansion-panel v-for="(kLaporan, id) in kLaporans" :key="id">
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="primary">
                $expand
              </v-icon>
            </template>
            <template v-slot:default="{ open }">
              <v-list three-line>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <v-row>
                      <v-col cols="12" lg="4">
                        <div class="body-2 grey--text">Nama Kegiatan</div>
                        <div class="body-1 black--text font-weight-medium">
                          {{ $getDeepObj(laporans, `${kLaporan}.kegiatan.0`) }}
                        </div>
                      </v-col>
                      <v-col cols="12" lg="3">
                        <div class="body-2 grey--text">Waktu Pelaksanaan</div>
                        <div class="body-1 black--text">
                          {{ $getDeepObj(laporans, `${kLaporan}.kegiatan.1`) }}
                        </div>
                      </v-col>
                      <v-col cols="12" lg="3">
                        <div class="body-2 grey--text">Jumlah Laporan</div>
                        <div class="body-1 black--text">
                          <span class="blue--text font-weight-medium">
                            {{ ($getDeepObj(laporans, `${kLaporan}.laporan`) || []).length }}
                          </span>
                          Laporan
                        </div>
                      </v-col>
                      <v-col cols="12" lg="2" class="my-auto text-right info--text font-weight-medium">
                        <div v-if="open"> Tampilkan Ringkas <v-icon right>mdi-down</v-icon> </div>
                        <div v-else> Tampilkan Semua <v-icon right>mdi-down</v-icon> </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="yellow lighten-5">
            <v-divider />
            <v-list class="yellow lighten-5 ml-3">
              <v-list-item>
                <v-list-item-avatar />
                <v-list-item-content class="pb-2">
                  <v-row class="mb-2">
                    <v-col cols="12" lg="6" class="my-auto font-weight-medium">Daftar Laporan</v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      class="text-right"
                      v-if="$allow('psp-peserta-pendampingan-lokakarya-dinas.create')"
                    >
                      <v-btn depressed color="success" class="text-capitalize" @click="onCreateLaporan(kLaporan)">
                        <v-icon left size="21">mdi-plus</v-icon>Tambah Laporan
                      </v-btn>
                    </v-col>
                  </v-row>
                  <template v-if="($getDeepObj(laporans, `${kLaporan}.laporan`) || []).length">
                    <div v-for="(laporan, id) in $getDeepObj(laporans, `${kLaporan}.laporan`)" :key="id">
                      <v-divider class="mb-4" />
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-row class="mb-2">
                            <v-col cols="12" lg="2">
                              <div class="body-2 grey--text">
                                Nama Laporan
                              </div>
                              <div class="body-1 black--text font-weight-medium"> Laporan ke-{{ id + 1 }} </div>
                            </v-col>
                            <v-col cols="12" lg="4">
                              <div class="body-2 grey--text">
                                Rencana Kegiatan
                              </div>
                              <div class="my-1">
                                <v-chip :class="['white--text', getStatusLaporan('rencana', laporan, 'color')]">
                                  {{ getStatusLaporan('rencana', laporan) }}
                                </v-chip>
                              </div>
                              <div class="body-2 black--text">
                                <div>
                                  <strong>Oleh: </strong>{{ $getDeepObj(laporan, 'akun_rencana.nama') || '-' }}
                                </div>
                                <div> <strong>Pada: </strong>{{ $getDeepObj(laporan, 'wkt_rencana') || '-' }} </div>
                              </div>
                            </v-col>
                            <v-col cols="12" lg="4">
                              <div class="body-2 grey--text">
                                Pelaksanaan Kegiatan
                              </div>
                              <div class="my-1">
                                <v-chip :class="['white--text', getStatusLaporan('pelaksanaan', laporan, 'color')]">
                                  {{ getStatusLaporan('pelaksanaan', laporan) }}
                                </v-chip>
                              </div>
                              <div class="body-2 black--text">
                                <div>
                                  <strong>Oleh: </strong>{{ $getDeepObj(laporan, 'akun_pelaksanaan.nama') || '-' }}
                                </div>
                                <div> <strong>Pada: </strong>{{ $getDeepObj(laporan, 'wkt_pelaksanaan') || '-' }} </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                        <v-list-item-action-text v-if="actionsMenu.length">
                          <base-list-action
                            :data="laporan"
                            :id="id"
                            :actions="actionsMenu"
                            :allow="allow"
                            @action="onAction"
                          />
                        </v-list-item-action-text>
                      </v-list-item>
                    </div>
                  </template>
                  <template v-else>
                    <div>
                      <v-divider class="mb-4" />
                      <v-row>
                        <v-col cols="12">
                          <em class="grey--text">Belum ada laporan</em>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
          <v-divider />
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <base-modal-full ref="modal" general-error :title="formulir.title" @save="onSaveLaporan">
      <component
        ref="formulir"
        :is="formulir.form"
        :masters="Object.assign({}, masters, mOpsi)"
        :info="formulir.info"
        :berkases="formulir.berkases"
        @refresh="onRefreshLaporan"
      />
    </base-modal-full>
  </div>
</template>

<script>
import FormRencana from './forms/Rencana';
import FormPelaksanaan from './forms/Pelaksanaan';
import list from '@mixins/list';
import actionsMenu from './actions';
import { mapActions, mapState } from 'vuex';
export default {
  mixins: [list],
  components: { FormRencana, FormPelaksanaan },
  data() {
    return {
      mOpsi: {},
      kLaporans: [],
      laporans: {},
      formulir: {},
      gelombang: 2,
      actionsMenu: actionsMenu,
      listLaporan: [
        {
          key: 'download',
          label: `Laporan Penjadwalan Kegiatan BGP/BBGP`,
        },
      ],
    };
  },
  created() {
    const gelombangs = this.$getDeepObj(this.configPendampingan, 'kp-pa.gelombang') || [];
    const [gelombang] = [...[], ...gelombangs].slice(-1);

    this.gelombang = gelombang;

    this.getMasters('lokakarya_moda_psp;propinsi;kota');
    this.getOpsi().then((resp) => {
      this.mOpsi = resp?.data || {};
    });
    this.fetchData();
  },
  computed: {
    ...mapState('master', ['masters']),
    ...mapState('preferensi', {
      preferensi: (state) => state.data,
      configPendampingan: (state) => (state.data && state.data.pendampingan) || {},
    }),

    mGelombang() {
      const gelombangs = this.$getDeepObj(this.configPendampingan, 'kp-pa.gelombang') || [];
      return [...[], ...gelombangs].reverse().map((value) => {
        return {
          text: `Angkatan ${value}`,
          value,
        };
      });
    },
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('lokakaryaDinas', ['fetch', 'getOpsi', 'getDetail', 'save', 'actions', 'downloadList']),

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign(
          {},
          this.params,
          { gelombang: this.gelombang },
          this.$isObject(this.filters) ? this.filters : {}
        );
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then((resp) => {
          const data = resp?.data || [];
          const meta = resp?.meta || {};
          const kegiatans = this.$getDeepObj(meta, 'config.lokakarya_kegiatan') || {};

          this.kLaporans = Object.keys(kegiatans);
          for (const kLaporan of this.kLaporans) {
            const laporan = data.filter((item) => +item.k_lokakarya_kegiatan_psp === +kLaporan);
            this.laporans[kLaporan] = Object.assign(
              {},
              { laporan: laporan || [] },
              { kegiatan: kegiatans[kLaporan] || [] }
            );
          }

          resolve(true);
        });
      });
    },

    getStatusLaporan(type, laporan, result = 'text') {
      const isLengkap = this.$getDeepObj(laporan, `status_lengkap.${type}`);
      let status = { text: 'Belum dilengkapi', color: 'red' };
      if (isLengkap) {
        status = { text: 'Sudah dilengkapi', color: 'green' };
      }

      return status[result];
    },

    async getLaporan(laporan) {
      let detail = {};
      const id = this.$getDeepObj(laporan, 'psp_kp_pa_lokakarya_dinas_id');

      if (this.$isObject(laporan || {})) {
        detail = await this.getDetail({ id });
      }

      return detail?.data || {};
    },

    downloadLaporan(url) {
      const params = Object.assign({}, { gelombang: this.gelombang });
      this.downloadList({ params, url: url.dokumen }).then((url) => {
        this.$downloadFile(url);
      });
    },

    allow(action, data) {
      let allow = true;

      switch (action.event) {
        case 'onEditPelaksanaan':
          allow = (data.status_lengkap && data.status_lengkap.rencana) || false;
          break;
        default:
          allow = this.$allow(action.akses);
          break;
      }

      return allow;
    },

    confirmHtml(data) {
      const laporan = this.$getDeepObj(this.laporans, `${data.k_lokakarya_kegiatan_psp}.kegiatan`) || [];
      return [
        {
          icon: 'mdi-account',
          iconSize: 50,
          iconColor: 'secondary',
          title: laporan[0] || '',
          subtitles: [`<span class="text--primary">${laporan[1]}</span>`],
        },
      ];
    },

    onAction(arg) {
      this[arg && arg.event && arg.event.event](arg && arg.data, arg && arg.id);
    },

    onChangeGelombang(value) {
      this.gelombang = value;
      this.onReload();
    },

    onCreateLaporan(kLaporan) {
      const kegiatan = this.$getDeepObj(this.laporans, `${kLaporan}.kegiatan`) || [];
      const info = Object.assign({}, { kegiatan }, { gelombang: this.gelombang }, { k_laporan: kLaporan });

      this.$set(this.formulir, 'id', '');
      this.$set(this.formulir, 'title', `Formulir Rencana Kegiatan`);
      this.$set(this.formulir, 'form', `FormRencana`);
      this.$set(this.formulir, 'info', info);
      this.$set(this.formulir, 'berkases', []);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onEditRencana(data) {
      this.onEditLaporan('Rencana', data);
    },

    onEditPelaksanaan(data) {
      this.onEditLaporan('Pelaksanaan', data);
    },

    async onEditLaporan(type, laporan) {
      const detail = await this.getLaporan(laporan);
      const kLaporan = laporan.k_lokakarya_kegiatan_psp;
      const kegiatan = this.$getDeepObj(this.laporans, `${kLaporan}.kegiatan`) || [];

      const info = Object.assign({}, { kegiatan }, { gelombang: this.gelombang }, { k_laporan: kLaporan }, { detail });
      const berkases = this.$getDeepObj(detail, 'psp_kp_pa_lokakarya_dinas_berkases.data') || [];

      this.$set(this.formulir, 'id', laporan.psp_kp_pa_lokakarya_dinas_id);
      this.$set(this.formulir, 'title', `Formulir ${this.$titleCase(type)} Kegiatan`);
      this.$set(this.formulir, 'form', `Form${this.$titleCase(type)}`);
      this.$set(this.formulir, 'info', info);
      this.$set(this.formulir, 'berkases', berkases);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onDeleteLaporan(data, id) {
      const msg = `<span class="body-1 black--text">Anda yakin ingin menghapus data <strong>laporan ke-${id +
        1}?</strong></span>`;
      this.$confirm(msg, `Hapus Laporan`, {
        tipe: 'warning',
        data: this.confirmHtml(data),
      }).then(() => {
        this.actions({ id: data.psp_kp_pa_lokakarya_dinas_id, action: 'delete' }).then(() => {
          this.$success(`Hapus laporan berhasil`);
          this.onReload();
        });
      });
    },

    async onRefreshLaporan(laporan) {
      const detail = await this.getLaporan(laporan);
      const berkases = this.$getDeepObj(detail, 'psp_kp_pa_lokakarya_dinas_berkases.data') || [];

      this.$set(this.formulir, 'berkases', berkases);
    },

    onSaveLaporan() {
      const action = !this.formulir.id ? 'create' : 'update';
      const params = this.$refs.formulir.getValue();

      this.save({ action, params, id: this.formulir.id || '' })
        .then(() => {
          this.$success(`Berhasil disimpan`);
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
